import utils from 'utils';

import {useContext} from 'react';
import appContext from "@/appContext.tsx";

// fixme! dehardcode
export const FooterMenu = () => {
    const {currentUser} = useContext(appContext).userContext;

    const data = {
        social: {
            facebook: 'https://www.facebook.com/cemat.cz/',
            instagram: 'https://www.instagram.com/cemat_trading/',
            linkedin: 'https://www.linkedin.com/company/2758499',
            youtube: 'https://www.youtube.com/user/cemattrading',
        },
    };

    return <div className={cmpClass}>
        <div className={classMap.container}>
            <div className={classMap.box}>
                <div className={classMap.list}>
                    <div className={classMap.title}>Informace</div>
                    <a href="/wiki/o-nas" target="_blank">O nás</a>
                    <a href="/wiki/montaz-a-lisovani-pneumatik" target="_blank">Montáž a lisování pneumatik</a>
                    <a href="/wiki/vseobecne-obchodni-podminky" target="_blank">Všeobecné obchodní podmínky</a>
                    <a href="/wiki/zpracovani-osobnich-udaju" target="_blank">Zpracování osobních údajů</a>
                    <a href="/wiki/reklamacni-rad" target="_blank">Reklamační řád</a>
                </div>
            </div>
            <div className={classMap.box}>
                <div className={classMap.list}>
                    <div className={classMap.title}>Kontakty</div>
                    <a href="/wiki/obchodni-oddeleni" target="_blank">Obchodní oddělení</a>
                    {
                        !!currentUser.id && <a href="/machine-request" target="_blank">Kontaktní formulář - poptávka</a>
                    }
                    <br/>
                    <a href="tel:+420596013541" target="_blank">tel.: +420 596 013 541</a>
                    <a href="mailto:cemat@cemat.cz" target="_blank">e-mail: cemat@cemat.cz</a>
                </div>
            </div>
            <div className={classMap.box + ' ' + classMap.boxNoMobile}>
                <div className={classMap.list}>
                    <div className={classMap.title}>Adresa</div>
                    <a href="https://maps.app.goo.gl/hS8TVjqzVAhSBsWh9">
                        ČEMAT trading, spol. s r.o.<br/>
                        Čs. armády 184<br/>
                        735 51 Bohumín<br/>
                    </a>
                </div>
                <div className={classMap.social}>
                    <a href={data.social.facebook} className="iconfab-facebook" target="_blank"></a>
                    <a href={data.social.instagram} className="iconfab-instagram" target="_blank"></a>
                    <a href={data.social.linkedin} className="iconfab-linkedin" target="_blank"></a>
                    <a href={data.social.youtube} className="iconfab-youtube" target="_blank"></a>
                </div>
            </div>
            <div className={classMap.box + ' ' + classMap.boxMobile}>
                <div className={classMap.social}>
                    <a href={data.social.facebook} className="iconfab-facebook" target="_blank"></a>
                    <a href={data.social.instagram} className="iconfab-instagram" target="_blank"></a>
                    <a href={data.social.linkedin} className="iconfab-linkedin" target="_blank"></a>
                    <a href={data.social.youtube} className="iconfab-youtube" target="_blank"></a>
                </div>
            </div>
        </div>
    </div>;
};

const cmpClass = 'footer-menu';
const classMap = utils.generateClassMap(cmpClass, {
    box: 'box',
    boxMobile: 'box--mobile',
    boxNoMobile: 'box--no-mobile',
    container: 'container container',
    list: 'list',
    menu: 'menu',
    social: 'social',
    title: 'title',
});
